<div id="drug-sales-analysis-summary-section">
  <div class="main-heading">
    <span>
      Sales Analysis
    </span>
  </div>
  <div nz-row nzType="flex">
    <div nz-col class="summary-text">
      <app-ark-container
        [future]="dataObservable"
        [loadingTemplate]="loading"
        [successTemplate]="success"
        [failureTemplate]="failure"
        [errorTemplate]="error"
        (onSuccess)="onDrugSalesDataResolved($event[0])"
      >
      </app-ark-container>
    </div>

    <div nz-col class="summary-chart">
      <app-ark-container
        [future]="chartDataObservable"
        [loadingTemplate]="loading"
        [successTemplate]="chartSuccess"
        [failureTemplate]="failure"
        [errorTemplate]="error"
        (onSuccess)="onDrugSalesChartDataResolved($event[0])"
        (onFailure)="onError($event[0])"
      >
      </app-ark-container>
    </div>
  </div>

  <ng-template #loading>
    <va-custom-skeleton [customSkeletonConfig]="customSkeletonConfig">
    </va-custom-skeleton>
  </ng-template>
  <ng-template #success>
    <app-drug-sales-summary-marketed-drug
      *ngIf="
        salesAnalysisData &&
        salesAnalysisData.drug_type &&
        salesAnalysisData.drug_type === 'marketed'
      "
      [data]="salesAnalysisData"
    ></app-drug-sales-summary-marketed-drug>
    <app-drug-sales-summary-pipeline-drug
      *ngIf="
        salesAnalysisData &&
        salesAnalysisData.drug_type &&
        salesAnalysisData.drug_type === 'pipeline'
      "
      [data]="salesAnalysisData"
    ></app-drug-sales-summary-pipeline-drug>
  </ng-template>
  <ng-template #failure>
    <div id="charts-error" class="error-container" *ngIf="showError">
      <div class="error-msg">
        <va-icon size="small" name="info-circle" class="info-icon" ></va-icon>
        <span class="error-text">{{
          errorMessage ? errorMessage : "Something went wrong!"
        }}</span>
      </div>
    </div>
  </ng-template>
  <ng-template #error>
    <div id="charts-error" class="error-container" *ngIf="showError">
      <div class="error-msg">
        <va-icon size="small" name="info-circle" class="info-icon" ></va-icon>
        <span class="error-text">{{
          errorMessage ? errorMessage : "Something went wrong!"
        }}</span>
      </div>
    </div>
  </ng-template>
  <ng-template #chartSuccess>
    <div class="chart-header">
      <div class="chart-name">
        <span>Revenue</span>
      </div>
      <div id="downloadButtonDiv">
        <button
          class="va-button va-icon-button va-button-outline va-button-outline--primary"
          title="Download"
          nz-dropdown
          [nzDropdownMenu]="menu"
        >
          <va-icon name="download" size="small"></va-icon>
        </button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item (click)="downloadValue(0)" class="download-opt">
              Download PNG
            </li>
            <li nz-menu-item (click)="downloadValue(2)" class="download-opt">
              Download PDF
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </div>
    <div class="chart-container">
      <div class="marketed-drug-chart">
        <highcharts-chart
          *ngIf="chartReady && !showError"
          [Highcharts]="highcharts"
          [options]="barChartOptions"
          [(update)]="updateFlag"
          style="width: 100%; height: 100%;display: block;"
          ngClass="drug"
          (chartInstance)="onHighchartsChartInstance($event)"
        >
        </highcharts-chart>
        <div
          id="charts-error"
          class="error-container"
          *ngIf="chartReady && showError"
        >
          <div class="error-msg">
            <va-icon
              size="small"
              name="info-circle"
              class="info-icon"
            ></va-icon>
            <span class="error-text">{{
              errorMessage ? errorMessage : "Something went wrong!"
            }}</span>
          </div>
        </div>
      </div>
      <!-- <div class="pipeline-drug-chart" *ngIf="drugType === 'Pipeline'">
        <highcharts-chart
          [Highcharts]="highcharts"
          [options]="stackChartOptions"
          style="width: 100%; height: 100%;display: block;"
          ngClass="drug"
        >
        </highcharts-chart>
      </div> -->
    </div>
  </ng-template>
</div>
